const productFilters = () => {
	/**
	 * Get all sections with product filters
	 * Exit early if no sections are found
	 */
	const sections = document.querySelectorAll('.ml-product-collection')

	if (!sections.length) return

	/**
	 * Function definitions
	 * Defined here to avoid hoisting issues
	 */
	const initializeSection = async (
		section,
    sortDefault,
		products,
		counters,
		panels,
		inputs,
		actives,
		banners,
	) => {
		/**
		 * Object to hold active filters
		 * Populated with input values when checked
		 * Example:
		 * {
		 *  category: [],
		 *  brand: [],
		 * }
		 */
		const activeFilters = panels.reduce((acc, curr) => {
			const key = curr.dataset.filterCategory
			if (!(key in acc)) {
				acc[key] = new Map()
			}
			return acc
		}, {})

    const defaultSortOrder = await fetchSortedProducts(sortDefault)
    const loadParams = getQueryParams()
    if ( !Object.keys(loadParams).length ) {
      inputs.forEach((input) => {
        if ( input.value === sortDefault ) {
          input.checked = true
          activeFilters['sort_by'].set(input.value, input.dataset.inputLabel)
        }
      })

      updateQueryParams('sort_by', sortDefault)
    }
    
    const collectionGrid = section.querySelector('[data-product-grid]')
    const collectionItems = new Map(
      products.map((product) => [parseInt(product.dataset.productId), product])
    )

		const sortedItems = new Map()
		const grid = new Map()
		grid.set('products', products)
		grid.set(
			'tags',
			products.map((product) => Array.from(product.dataset.tags.split(','))),
		)

		let checkedInputs = 0
		let filteredCount = grid.get('products').length
		let productCount = grid.get('products').length

		const updateFilteredProducts = () => {
			let activeCount
			const items = grid.get('products')
			const tags = grid.get('tags')

			if (checkedInputs === 0) {
				section.removeAttribute('data-filters-active')
				items.forEach((product) => product.classList.remove('hidden'))
				activeCount = productCount
				updateProductCount(counters, activeCount)
				return
			} else {
				const filters = Object.keys(activeFilters).flatMap((key) =>
					Array.from(activeFilters[key].keys()),
				)
				filteredCount = filterElementVisibility(items, tags, filters)
				activeCount = filteredCount
				updateProductCount(counters, activeCount)
			}

			positionBanners(banners, activeCount, activeFilters)
		}

		const removeFilterTag = (e) => {
			const { currentTarget } = e
			const {
				dataset: { filterArray, filterKey },
			} = currentTarget
			const inputPair = inputs.reduce((acc, curr) => {
				if (curr.value === filterKey) acc.push(curr)
				return acc
			}, [])
			inputPair.forEach((input) => (input.checked = false))
			activeFilters[filterArray].delete(filterKey)
			actives.forEach((active) => {
				let button = active.querySelector(`[data-filter-key="${filterKey}"]`)
				button.remove()
			})
			checkedInputs--

			updateQueryString(activeFilters)
			updateFilteredProducts()
		}

		const updateSortOrder = async (value, label) => {
			if (sortedItems.size) {
				const [key] = Array.from(sortedItems.keys())
				const currentInput = inputs.find((input) => input.value === key)
				if (currentInput) currentInput.checked = false
			}

			sortedItems.clear()
			sortedItems.set(value, label)

			updateQueryParams('sort_by', value)
			sortedItems.clear()
      const sortOrder = getSortBy()
			const data = await fetchSortedProducts(sortOrder)
			updateGridItems(collectionGrid, collectionItems, data)

			updateFilteredProducts()
		}

		const handleInputChange = (e) => {
			const { currentTarget } = e
			const {
				checked,
				name,
				value,
				dataset: { inputLabel },
			} = currentTarget

			const isModal = currentTarget.closest('.modal__body') !== null
			const searchPanel = isModal
				? section.querySelector('.form__desktop')
				: section.querySelector('.modal__body')
			const pairedInput = searchPanel.querySelector(
				`[name="${name}"][value="${value}"`,
			)

			if (pairedInput) pairedInput.checked = checked

			if (name === 'sort_by') {
				const sortInputs = inputs.filter((input) => input.name === 'sort_by')
				sortInputs.forEach((input) => {
					if (input.value !== value) input.checked = false
				})

        if ( checked ) {
          updateSortOrder(value, inputLabel)
          return
        }
        else {
          updateGridItems(collectionGrid, collectionItems, defaultSortOrder)
          removeSortParams(name, value)
        }

        return
			}

			if (checked) {
				checkedInputs++
				if (checkedInputs === 1) section.setAttribute('data-filters-active', '')

				if (name === 'flavor') {
					const flavor = activeFilters.flavor

					if (flavor.size) {
						const [key] = Array.from(flavor.keys())
						const currentInput = inputs.find((input) => input.value === key)

						actives.forEach((active) => {
							let button = active.querySelector(`[data-filter-key="${key}"]`)
							if (button) button.remove()
						})

						if (currentInput) currentInput.checked = false
						checkedInputs--
					}

					flavor.clear()
					flavor.set(value, inputLabel)
				}

				activeFilters[name].set(value, inputLabel)
				actives.forEach((active) => {
					const button = createFilterTag(
						name,
						value,
						inputLabel,
						removeFilterTag,
					)
					active.appendChild(button)
				})
			} else {
				checkedInputs--

				actives.forEach((active) => {
					const button = active.querySelector(`[data-filter-key="${value}"]`)
					if (button) button.remove()
				})

				activeFilters[name].delete(value)
			}

			updateFilteredProducts()
			updateQueryString(activeFilters)
		}

		positionBanners(banners, productCount, activeFilters)

		inputs.forEach((input) => {
			input.addEventListener('change', handleInputChange)
		})

		applyQueryParams(inputs)
	}

	const positionBanners = (banners, count, filters) => {
		banners.forEach((banner) => {
			const tags = banner.dataset.tags.split(',')
			const hasActiveFilters = Object.values(filters).some(
				(items) => items.length > 0,
			)
			const matchesActiveFilters = Object.values(filters).every((items) => {
				if (!hasActiveFilters) return true
				return items.some((item) => tags.includes(item))
			})

			const isVisible = !hasActiveFilters || matchesActiveFilters
			banner.classList.toggle('hidden', !isVisible)
			banner.classList.remove('first', 'second')
		})

		const visibleBanners = banners.filter(
			(banner) => !banner.classList.contains('hidden'),
		)

		if (visibleBanners.length > 0 && count > 4)
			visibleBanners[0].classList.add('first')
		if (visibleBanners.length > 1 && count > 4)
			visibleBanners[1].classList.add('second')
	}

	const applyQueryParams = (inputs) => {
		const queryParams = getQueryParams()
		for (const [key, value] of Object.entries(queryParams)) {
			if (key === 'sort_by') {
				const input = inputs.find((input) => input.value === value)
				if (input) input.checked = true
			} else {
				const inputValues = value.split(',')
				inputValues.forEach((inputValue) => {
					const input = inputs.find((input) => input.value === inputValue)
					if (input) {
						input.checked = true
						input.dispatchEvent(new Event('change'))
					}
				})
			}
		}
	}

	const updateQueryString = (activeFilters) => {
		const queryParams = getQueryParams()

		for (const [filterKey, filterMap] of Object.entries(activeFilters)) {
			if (filterKey === 'sort_by') {
				continue
			}

			if (queryParams.hasOwnProperty(filterKey)) {
				if (filterMap.size === 0) {
					delete queryParams[filterKey]
				} else {
					const activeKeys = Array.from(filterMap.keys())
					queryParams[filterKey] = activeKeys.join(',')
				}
			} else if (filterMap.size > 0) {
				const activeKeys = Array.from(filterMap.keys())
				queryParams[filterKey] = activeKeys.join(',')
			}
		}

		if (queryParams.hasOwnProperty('sort_by')) {
			const sortBy = queryParams['sort_by']
			delete queryParams['sort_by']
			queryParams['sort_by'] = sortBy
		}

		const updatedQueryString = Object.entries(queryParams)
			.map(
				([key, value]) =>
					`${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
			)
			.join('&')
    const newUrl = `${window.location.pathname}?${updatedQueryString}`
		window.history.replaceState(null, null, newUrl)
	}

	const getCollectionHandle = () => {
		const url = new URL(window.location.href)
		const pathnameParts = url.pathname.split('/')
		return pathnameParts[pathnameParts.indexOf('collections') + 1]
	}

  const removeSortParams = () => {
    const params = getQueryParams()
    if (params.hasOwnProperty('sort_by')) {
      delete params['sort_by']
    }
    const updatedQueryString = Object.entries(params)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
      )
      .join('&')

    const newUrl = updatedQueryString === ''
      ? `${window.location.pathname}`
      : `${window.location.pathname}?${updatedQueryString}`
    window.history.replaceState(null, null, newUrl)
  }

	const getSortBy = () => {
		const url = new URL(window.location.href)
		return url.searchParams.get('sort_by')
	}

	const updateQueryParams = (key, value) => {
		const url = new URL(window.location.href)
		const params = new URLSearchParams(url.search)
		params.set(key, value)
		url.search = params.toString()
		window.history.replaceState(null, null, url.toString())
	}

	const getQueryParams = () => {
		if (location.search.length) {
			return location.search
				.slice(1)
				.split('&')
				.reduce((queryParams, param) => {
					const [key, value] = param.split('=')
					if (key) {
						queryParams[decodeURIComponent(key)] = decodeURIComponent(value)
					}
					return queryParams
				}, {})
		}
		return {}
	}

	const updateGridItems = (grid, items, data) => {
    const sortedIds = data.map((item) => item.id)
		const fragment = document.createDocumentFragment()

		sortedIds.forEach((id) => {
			const product = items.get(id)
			if (product) {
				fragment.appendChild(product)
			}
		})

		grid.innerHTML = ''
		grid.appendChild(fragment)
	}

	const fetchSortedProducts = async (sortOrder) => {
		const collectionHandle = getCollectionHandle()
		const sortBy = sortOrder
		const fetchUrl = `/collections/${collectionHandle}?sort_by=${sortBy}&view=sort-by`

		try {
			const response = await fetch(fetchUrl, {
				method: 'GET',
				headers: {
					Accept: 'text/html',
				},
			})

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`)
			}

			return await response.json()
		} catch (error) {
			console.error('Error fetching sorted products:', error)
		}
	}

	const filterElementVisibility = (items, tags, keys) => {
		return tags.reduce((acc, curr, index) => {
			const product = items[index]
			const hasTag = curr.some((tag) => keys.includes(tag))

			if (hasTag) {
				product.classList.remove('hidden')
				acc++
			} else {
				product.classList.add('hidden')
			}

			return acc
		}, 0)
	}

	const updateProductCount = (counters, count) => {
		counters.forEach((counter) => {
			const plural = count === 1 ? '' : 's'
			counter.textContent = `${count} result${plural}`
		})
	}

	const collapsePanel = (panel) => {
		const collapsible = panel.querySelector('.collapse')
		if (!collapsible) return

		collapsible.classList.remove('show')
	}

	const closeOnClick = (panels) => {
		panels.forEach((panel) => {
			panel.addEventListener('click', (e) => {
				if (activePanel === null) {
					activePanel = panel
					return
				}

				if (activePanel !== panel) {
					collapsePanel(activePanel)
					activePanel = panel
				}
			})
		})

		document.addEventListener('click', (e) => {
			if (!activePanel) return

			const isOutside = panels.every((panel) => {
				return !panel.contains(e.target)
			})

			if (isOutside) {
				collapsePanel(activePanel)
				activePanel = null
			}
		})
	}

	const stickOnScroll = (section) => {
		const filters = section.querySelector('.collection__filters')
		const filtersTop = filters.getBoundingClientRect().top + window.scrollY
		const filtersHeight = filters.offsetHeight

		document.documentElement.style.setProperty(
			'--filters-height',
			`${filtersHeight}px`,
		)

		window.addEventListener('scroll', () => {
			const scrolled = window.scrollY

			if (scrolled >= filtersTop) {
				filters.classList.add('filters__sticky')
			} else {
				filters.classList.remove('filters__sticky')
			}
		})
	}

	const createFilterTag = (name, value, label, callback) => {
		const button = document.createElement('button')
		const icon = document.createElement('span')
		const text = document.createElement('span')

		button.classList.add('ml-button--filter-badge')
		button.setAttribute('type', 'button')
		button.setAttribute('aria-label', `Remove ${label}`)
		button.setAttribute('data-filter-badge', '')
		button.setAttribute('data-filter-array', name)
		button.setAttribute('data-filter-key', value)

		icon.classList.add('icon-close')
		icon.classList.add('ml-badge--icon')

		text.textContent = label
		text.classList.add('ml-badge--text')

		button.appendChild(icon)
		button.appendChild(text)

		button.addEventListener('click', callback)

		return button
	}

	/**
	 * Define selectors
	 * Initialize sections
	 */
	const selectors = {
    sortDefault: '[data-sort-default]',
		filterProduct: '[data-filter-product]',
		filterCount: '[data-filter-count]',
		filterPanel: '[data-filter-panel]',
		filterInput: '[data-filter-input]',
		activeContainer: '[data-active-filters]',
	}

	/**
	 * Constants and globals
	 */
	let activePanel = null
	const allPanels = Array.from(document.querySelectorAll(selectors.filterPanel))

	/**
	 * Initialize sections
	 */

	// close all panels when clicking outside
	// close previous panel when opening a new one (only in modal)
	closeOnClick(allPanels)

	for (const section of sections) {
		stickOnScroll(section)
    
    const sortDefault = section.querySelector(selectors.sortDefault).dataset.sortDefault

		const products = Array.from(
			section.querySelectorAll(selectors.filterProduct),
		)
		const counters = Array.from(section.querySelectorAll(selectors.filterCount))
		const panels = Array.from(
			section.querySelectorAll(`.form__desktop ${selectors.filterPanel}`),
		)
		const inputs = Array.from(section.querySelectorAll(selectors.filterInput))
		const actives = Array.from(
			section.querySelectorAll(selectors.activeContainer),
		)
		const banners = Array.from(
			section.querySelectorAll('[data-product-banner]'),
		)

		initializeSection(
			section,
      sortDefault,
			products,
			counters,
			panels,
			inputs,
			actives,
			banners,
		)
	}
}

export default productFilters
